import { useServices } from "../services/Services";
import { getDomainFromUrl, isInternalEvent } from "../helper/helper";
import { formatDate } from "../helper/helper";
import { EntityItem } from "../common-types/Entity";
import { EventSourcesMap } from "../common-types/EventSource";

export const useEventSources = (
  referencedEntities: EntityItem[],
): {
  eventSources: EventSourcesMap;
  isLoading: boolean;
  error: Error | null;
  missingEventIds: string[];
} => {
  const services = useServices();

  const validEventIds = [
    ...new Set(referencedEntities.map((entity) => entity.id)),
  ];

  const {
    data: events,
    isLoading,
    error,
  } = services.Event.useGetSourceEventsByIds(validEventIds);

  let eventSources: EventSourcesMap = {};
  let missingEventIds: string[] = validEventIds;

  if (events && events.length > 0) {
    const sourcesMap: EventSourcesMap = {};
    const foundEventIds = events.map((event) => event.id);
    const missingIds = validEventIds.filter(
      (id) => !foundEventIds.includes(id),
    );

    events.forEach((event) => {
      if (event.id) {
        const isInternalEventEvent = isInternalEvent(event.sourceType);
        const sourceLabel = isInternalEventEvent
          ? "Unruly / AFP"
          : event.newsSourceUrl
            ? (getDomainFromUrl(event.newsSourceUrl) ?? undefined)
            : undefined;
        sourcesMap[event.id] = {
          sourceUrl: event.newsSourceUrl ?? undefined,
          sourceLabel,
          sourceName: event.source ?? undefined,
          eventName: event.name ?? undefined,
          eventSummary: event.eventSummary ?? undefined,
          eventDate: event.startDate ? formatDate(event.startDate) : undefined,
          isInternalEvent: isInternalEventEvent,
        };
      }
    });

    eventSources = sourcesMap;
    missingEventIds = missingIds;
  }

  return {
    eventSources,
    isLoading,
    error: error as Error,
    missingEventIds,
  };
};
